import React from 'react'
import CircleLoader from './CircleLoader'
import "./component.css"
const Loadingpage = () => {
  return (
    <div className='loading-page'><CircleLoader color='#764c24' label='Authenticating...'/></div>
  )
}

export default Loadingpage